import { useMemo } from "react";
import { useParams } from "react-router-dom";

function isValidGUID(str: string) {
    let regex = new RegExp(/^[{]?[0-9a-fA-F]{8}[-]?([0-9a-fA-F]{4}[-]?){3}[0-9a-fA-F]{12}[}]?$/);

    if (str == null) {
        return false;
    }

    if (regex.test(str) == true) {
        return true;
    }
    else {
        return false;
    }
}

export const useGetFriendlyUrlParam = (key: string): string => {
    const params = useParams();
    // @ts-ignore
    const value = params[key];

    return getFriendlyUrlParamId(value);
}

export const extractGuidFromId = (id: string): string => {
    return id?.split("-").reverse()?.[0] ?? "";
}

export const getFriendlyUrlParamId = (value: string): string => {
    const paramId = useMemo(() => extractGuidFromId(value), [value]);

    if (isValidGUID(paramId)) {
        return paramId;
    }
    else {
        return value;
    }
}

import { useMemo } from "react";
import { useParams } from "react-router-dom";

function isValidGUID(str: string) {
    let regex = new RegExp(/^[{]?[0-9a-fA-F]{8}[-]?([0-9a-fA-F]{4}[-]?){3}[0-9a-fA-F]{12}[}]?$/);

    if (str == null) {
        return false;
    }

    if (regex.test(str) == true) {
        return true;
    }
    else {
        return false;
    }
}

export const useGetFriendlyUrlParam = (key: string): string => {
    const params = useParams();
    // @ts-ignore
    const value = params[key];

    return getFriendlyUrlParamId(value);
}

export const extractGuidFromId = (id: string): string => {
    return id?.split("-").reverse()?.[0] ?? "";
}

export const getFriendlyUrlParamId = (value: string): string => {
    const paramId = useMemo(() => extractGuidFromId(value), [value]);

    if (isValidGUID(paramId)) {
        return paramId;
    }
    else {
        return value;
    }
}

